import React, { useState } from "react"
import testData from "../data/reviews.json"
import styled from "styled-components"

const ReviewsCard = () => {
  // eslint-disable-next-line
  const [data, setData] = useState(testData)
  return (
    <Container>
      {data.map(item => (
        <div className="card">
          <div className="profile" key={item.id}>
            <img className="profile-img" src={item.image} alt={item.name} />
            <blockquote className="quote">{item.quote}</blockquote>
            <h5>{item.name}</h5>
          </div>
        </div>
      ))}
    </Container>
  )
}

export default ReviewsCard

const Container = styled.div`
  margin-top: 100px;
  text-align: center;
  display: grid;

  .card {
    margin-left: 1rem;
    margin-top: 6rem;
  }

  .profile {
    position: relative;
    padding: 70px 10px 10px;
    background-color: var(--primary-100);
    h5 {
      color: var(--primary-900);
    }
  }

  .profile-img {
    position: absolute;
    top: -60px;
    left: calc(50% -60px);
    border: 10px solid white;
    width: 120px;
    height: 120px;
    border-radius: 50%;
    object-fit: cover;
  }

  .quote {
    letter-spacing: var(--letterSpacing);
    &:before {
      content: open-quote;
      font-size: 4rem;
      position: relative;
      color: var(--primary-700);
      line-height: 20px;
      bottom: -15px;
      right: 5px;
    }
    &:after {
      content: close-quote;
      font-size: 3rem;
      position: relative;
      color: var(--primary-700);
      line-height: 10px;
      bottom: -15px;
      left: 5px;
    }
  }

  @media (min-width: 768px) {
    grid-template-columns: 1fr 1fr;
  }
  @media (min-width: 992px) {
    grid-template-columns: 1fr 1fr 1fr;
  }
`
